
const Footer = () => {
  return (
    <div className="footer-wrapper">All rights reserved © 2023</div>
  )
}

export default Footer